import { mapState, mapMutations } from 'vuex'
import { tierOfAccount, tierAllows, limitForTier, requiredTier, COMPANY_FULL_FEATURES } from '@/utils/Plans'

export const planMixin = {
    computed: {
        ...mapState(['planOwner']),
        planTier(vm = this) {
            const account = vm.account
            if (!account) return null
            const ownTier = tierOfAccount(account)
            if (ownTier) return ownTier
            const type = account.accountType
            if (type === 'coach_company' || type === 'student') return tierOfAccount(vm.planOwner)
            return null
        },
    },
    methods: {
        ...mapMutations(['showPlanRequired']),
        can(feature) {
            const vm = this
            if (vm.account?.accountType === 'company' && vm.planTier && COMPANY_FULL_FEATURES.includes(feature)) return true
            return tierAllows(vm.planTier, feature)
        },
        requirePlan(feature) {
            const vm = this
            if (vm.can(feature)) return true
            vm.showPlanRequired({ feature })
            return false
        },
        limitOf(key) {
            return limitForTier(this.planTier, key)
        },
        requireLimit(key, used = 0, notice = null) {
            const vm = this
            const max = vm.limitOf(key)
            if (used < max) return true
            vm.showPlanRequired({ limitKey: key, used, max, notice })
            return false
        },
        planOf(feature) {
            return requiredTier(feature)
        },
    },
}
